import React from "react";

import { IFaqs } from "~/types/api-types";

import { displaySections } from "../data/event-faq-display-sections";

import AlcoholSection from "./AlcoholSection";
import AVMusicSection from "./AVMusicSection";
import EventActivitiesSection from "./EventActivitiesSection";
import EventRulesSection from "./EventRulesSection";
import FoodBeverageSection from "./FoodBeverageSection";
import FurnitureSection from "./FurnitureSection";
import RestroomsSection from "./RestroomsSection";

interface EventFaqProps {
  faqData: IFaqs;
  userID: string;
  listingID: string;
}

const EventFaq: React.FC<EventFaqProps> = ({ faqData, userID, listingID }) => {
  return (
    <div>
      {displaySections.displayFoodBeverageSection(faqData) && (
        <FoodBeverageSection
          faqData={faqData}
          userID={userID}
          listingID={listingID}
        />
      )}
      {displaySections.displayAlcoholSection(faqData) && (
        <AlcoholSection
          faqData={faqData}
          userID={userID}
          listingID={listingID}
        />
      )}
      {displaySections.displayFurnitureSection(faqData) && (
        <FurnitureSection
          faqData={faqData}
          userID={userID}
          listingID={listingID}
        />
      )}
      {displaySections.displayRestroomSection(faqData) && (
        <RestroomsSection
          faqData={faqData}
          userID={userID}
          listingID={listingID}
        />
      )}
      {displaySections.displayAVMusicSection(faqData) && (
        <AVMusicSection
          faqData={faqData}
          userID={userID}
          listingID={listingID}
        />
      )}
      {displaySections.displayEventActivitiesSection(faqData) && (
        <EventActivitiesSection
          faqData={faqData}
          userID={userID}
          listingID={listingID}
        />
      )}
      {displaySections.displayEventRulesSection(faqData) && (
        <EventRulesSection
          faqData={faqData}
          userID={userID}
          listingID={listingID}
        />
      )}
    </div>
  );
};

export default EventFaq;
